












































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BModal, BCarousel } from 'bootstrap-vue';
import { Sheet, SheetField, Student, SheetActivity, FieldActivity, ScoreOption } from "../../modules/teacher/SaitenList";

const ModalImageKindEnum = Object.freeze({Scan: 1, Result: 2});

export interface Data {
  sheet_id: string
  sheet: Sheet | null
  sheetFields: SheetField[] | null
  students: Student[] | null
  studentNameWidth: number
  rightTableTdWidth: string
  colspan: number
  totalScoreAverage: number
  totalScoreRate: number
  totalFieldCount: number
  totalFirstSaitenCompletedCount: number
  totalSecondSaitenCompletedCount: number
  delayedJobCount: number
  isSaitenCompleted: boolean
  isStudentNoSortDesc: boolean
  isTotalScoreSortDesc: boolean
  isFieldScoreSortDest: boolean
  isPdfJobProcessing: boolean
  modalStudent: Student | null
  modalImageKind: number
  carouselPageIdx: number
  ModalImageKindEnum: Readonly<{Scan: number; Result: number;}>
  windowHeight: number
  scoreOptions: ScoreOption[]
  errors: string[]
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const modalRef = ref<InstanceType<typeof BModal>>();
    const carouselRef = ref<InstanceType<typeof BCarousel>>();

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: "",
      sheet: null,
      sheetFields: new Array<SheetField>(),
      students: new Array<Student>(),
      studentNameWidth: 0,
      rightTableTdWidth: "",
      colspan: 5,
      totalScoreAverage: 0,
      totalScoreRate: 0,
      totalFieldCount: 0,
      totalFirstSaitenCompletedCount: 0,
      totalSecondSaitenCompletedCount: 0,
      delayedJobCount: 0,
      isSaitenCompleted: false,
      isStudentNoSortDesc: false,
      isTotalScoreSortDesc: false,
      isFieldScoreSortDest: false,
      isPdfJobProcessing: false,
      modalStudent: null,
      modalImageKind: ModalImageKindEnum.Scan,
      ModalImageKindEnum: ModalImageKindEnum,
      carouselPageIdx: 0,
      windowHeight: 0,
      scoreOptions: new Array<ScoreOption>(),
      errors: [],
    });

    /************************************************************
     * 一覧の高さを画面サイズに合わせる
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const tableArea = document.getElementById("table-area");
      state.windowHeight = windowHeight;

      if(tableArea != null){
        tableArea.style.height = (windowHeight - tableArea.offsetTop) + "px";
      }
    };

    /************************************************************
     * テーブルスクロールイベント
     ************************************************************/

    const scrollChanged = () => {
      const topRightTableArea: Element = document.getElementById("top-right-table-area");
      const bottomLeftTableArea: Element = document.getElementById("bottom-left-table-area");
      const bottomRightTableArea: Element = document.getElementById("bottom-right-table-area");

      topRightTableArea.scrollLeft = bottomRightTableArea.scrollLeft;
      bottomLeftTableArea.scrollTop = bottomRightTableArea.scrollTop;
    };

    /************************************************************
     * ヘッダの実施日用文言生成
     ************************************************************/

    const convertExecDateText = (execDate: string) => {
      return execDate ? moment(execDate).format('Y年M月D日実施') : "";
    };

    /************************************************************
     * 採点画像・エクセル出力可否判定
     ************************************************************/

    const isExcelPdfButtonEnable = computed((): boolean => {
      return state.isSaitenCompleted;
    });

    /************************************************************
     * 採点画像ボタン表示判定
     ************************************************************/

    const isPdfButtonVisible = computed((): boolean => {
      // admin権限でログインIDがtest_userを含むユーザのみ表示
      return context.root.$store.state.currentUser.role == Common.RoleEnum.Admin && context.root.$store.state.currentUser.login_id.includes("test_user");
    });

    /************************************************************
     * 画像作成ボタン押下
     ************************************************************/

    const createPdfJob = async () => {
      if(!window.confirm("採点画像作成を実行します。よろしいですか？")){
        return;
      }

      await http.post(`/api/saiten_list/create_pdf_job/${state.sheet_id}`).then(response => {
        alert("採点画像作成を開始しました");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * Excel出力ボタン押下
     ************************************************************/

    const downloadExcel = async () => {
      if(!window.confirm("採点結果Excelファイルを出力します。よろしいですか？")){
        return;
      }

      await http.get(`/api/saiten_list/download_excel/${state.sheet_id}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `saiten_result_${moment().format('Y-M-D')}.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /************************************************************
     * 承認ボタン押下
     ************************************************************/

    const updateApproval = async () => {
      if(!window.confirm("この試験を承認します。よろしいですか？")){
        return;
      }

      await http.post(`/api/saiten_list/update_approval/${state.sheet_id}`).then(response => {
        alert("処理が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /************************************************************
     * 出席番号列でソート
     ************************************************************/

    const sortStudentNo = () => {
      state.isStudentNoSortDesc = !state.isStudentNoSortDesc;
      if(state.isStudentNoSortDesc){
        state.students = state.students.sort((a, b) => a.number - b.number).reverse();
      }else{
        state.students = state.students.sort((a, b) => a.number - b.number);
      }
    }

    /************************************************************
     * 合計得点列でソート
     ************************************************************/

    const sortTotalScore = () => {
      state.isTotalScoreSortDesc = !state.isTotalScoreSortDesc;
      if(state.isTotalScoreSortDesc){
        state.students = state.students.sort((a, b) => a.score - b.score).reverse();
      }else{
        state.students = state.students.sort((a, b) => a.score - b.score);
      }
    };

    /************************************************************
     * 設問列でソート
     ************************************************************/

    const sortFieldScore = (idx: number) => {
      state.isTotalScoreSortDesc = !state.isTotalScoreSortDesc;
      if(state.isTotalScoreSortDesc){
        state.students = state.students.sort((a, b) => sortFieldScoreSub(idx, a, b)).reverse();
      }else{
        state.students = state.students.sort((a, b) => sortFieldScoreSub(idx, a, b));
      }
    };

    /************************************************************
     * 設問列のソートロジック 得点でソートする
     * 誤答・未採点・欠席者を区別するため
     * ダミー特典として未採点は-1、欠席者は-2でソートする
     ************************************************************/

    const sortFieldScoreSub = (idx: number, e1: Student, e2: Student) => {
      let scoreA = 0, scoreB = 0;
      if(e1.fieldActivities.length > idx){
        scoreA = e1.fieldActivities[idx].score == null ? -1 : e1.fieldActivities[idx].score;
      }else{
        scoreA = -2;
      }
      if(e2.fieldActivities.length > idx){
        scoreB = e2.fieldActivities[idx].score == null ? -1 : e2.fieldActivities[idx].score;
      }else{
        scoreB = -2;
      }
      return scoreA - scoreB;
    }

    /************************************************************
     * モーダル種別に応じた答案or採点結果画像base64を返却
     ************************************************************/

    const base64Images = computed((): string[] => {
      if(state.modalStudent == null){
        return [];
      }else if(state.modalImageKind == state.ModalImageKindEnum.Scan){
        return state.modalStudent.base64ScanImages;
      }else{
        return state.modalStudent.base64ResultImages
      }
    });

    /************************************************************
     * モーダルのtitleを返却
     ************************************************************/

    const modalTitle = computed((): string => {
      if(state.modalStudent == null){
        return "";
      }

      if(state.modalImageKind == state.ModalImageKindEnum.Scan){
        return `答案画像　出席番号：${state.modalStudent.number}番`;
      }else{
        return `採点結果　出席番号：${state.modalStudent.number}番`;
      }
    });

    /************************************************************
     * 画像モーダル表示
     ************************************************************/

    const showModalImage = async (student: Student, imageKind: number) => {

      if((imageKind == state.ModalImageKindEnum.Scan && student.base64ScanImages.length == 0)
        || (imageKind == state.ModalImageKindEnum.Result && student.base64ResultImages.length == 0)){
        // 画像をダウンロード
        const isSuccess: boolean = await downloadImage(student, imageKind)
        if(!isSuccess){
          // ダウンロード失敗は処理終了
          return;
        }
      }
      state.modalStudent = student;
      state.modalImageKind = imageKind;
      state.carouselPageIdx = 0;
      modalRef.value.show();
      carouselRef.value.setSlide(state.carouselPageIdx);
    };

    /************************************************************
     * 答案画像モーダル用画像ダウンロード
     ************************************************************/

    const downloadImage = async (student: Student, imageKind: number) => {
      let isSuccess = true;
      context.root.$store.dispatch("showOverlay");
      const sheetActivityIds = student.sheetActivities.map(x => x.id);
      await http.get(`/api/saiten_list/download_image/${state.sheet_id}/${sheetActivityIds}/${imageKind}`).then(response => {
        response.data.base64_images.forEach((x: string) => {
          if(imageKind == state.ModalImageKindEnum.Scan){
            student.base64ScanImages.push(x);
          }else{
            student.base64ResultImages.push(x);
          }
        });
      })
      .catch(error=>{
        isSuccess = false;
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      return isSuccess;
    };

    /************************************************************
     * 画像モーダル 前ページへ
     ************************************************************/

    const carouselPrev = () => {
      carouselRef.value.prev();
      if(state.carouselPageIdx > 0){
        state.carouselPageIdx--;
      }else{
        state.carouselPageIdx = state.sheet.page_count - 1;
      }
    };

    /************************************************************
     * 画像モーダル 次ページへ
     ************************************************************/

    const carouselNext = () => {
      carouselRef.value.next();
      if(state.carouselPageIdx + 1 < state.sheet.page_count){
        state.carouselPageIdx++;
      }else{
        state.carouselPageIdx = 0;
      }
    };

    /************************************************************
     * 画像モーダル 前の生徒へ
     ************************************************************/

    const changePrevModalStudent = async () => {
      const idx = state.students.indexOf(state.modalStudent);
      for(let i = idx - 1; i >= 0; i--){
        const student = state.students[i];
        
        // 欠席生徒はスキップ
        if(student.sheetActivities.length > 0){
          if((state.modalImageKind == state.ModalImageKindEnum.Scan && student.base64ScanImages.length == 0)
            || (state.modalImageKind == state.ModalImageKindEnum.Result && student.base64ResultImages.length == 0)){
            // 画像をダウンロード
            const isSuccess: boolean = await downloadImage(student, state.modalImageKind)
            if(!isSuccess){
              // ダウンロード失敗は処理終了
              return;
            }
          }
          state.modalStudent = student;
          carouselRef.value.setSlide(state.carouselPageIdx);
          break;
        }
      }
    };

    /************************************************************
     * 画像モーダル 次の生徒へ
     ************************************************************/

    const changeNextModalStudent = async () => {
      const idx = state.students.indexOf(state.modalStudent);
      for(let i = idx + 1; state.students.length; i++){
        const student = state.students[i];

        // 欠席生徒はスキップ
        if(student.sheetActivities.length > 0){
          if((state.modalImageKind == state.ModalImageKindEnum.Scan && student.base64ScanImages.length == 0)
            || (state.modalImageKind == state.ModalImageKindEnum.Result && student.base64ResultImages.length == 0)){
            // 画像をダウンロード
            const isSuccess: boolean = await downloadImage(student, state.modalImageKind)
            if(!isSuccess){
              // ダウンロード失敗は処理終了
              return;
            }
          }
          state.modalStudent = student;
          carouselRef.value.setSlide(state.carouselPageIdx);
          break;
        }
      }
    };

    /************************************************************
     * ダウンロードヘッダチェックボックス変更イベント
     ************************************************************/

    const allSelectChanged = (changedVal: boolean) => {
      state.students.forEach(x => {
        x.checked = changedVal;
      });
    };

    /************************************************************
     * ダウンロードアイコン押下
     ************************************************************/

    const downloadPdf = async () => {

      const studentIds = state.students.filter(x => x.checked).map(x => x.user_id);
      if(studentIds.length == 0){
        alert("ダウンロード対象の生徒を選択してください。");
        return;
      }

      if(!window.confirm("PDFをダウンロードします。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.get(`/api/saiten_list/download_pdf/${state.sheet_id}/${studentIds}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/zip' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${state.sheet_id}.zip`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * ペンシルアイコン押下 採点画面へ遷移
     ************************************************************/

    const saitenStart = (sheetField: SheetField) => {
      if(sheetField.scoring_type == Common.ScoringTypeEnum.Seigo){
        context.root.$router.push(`/teacher_site/saiten_input/${state.sheet_id}/${sheetField.id}`).catch(err => {});
      }else if(Common.IsScoringTypeScoreStamp(sheetField.scoring_type)){
        context.root.$router.push(`/teacher_site/saiten_input_score_stamp/${state.sheet_id}/${sheetField.id}`).catch(err => {});
      }
    }

    /************************************************************
     * 配点プルダウン変更
     ************************************************************/

    const allotChanged = async (sheetField: SheetField) => {

      if(!window.confirm("配点を変更しますか？")){
        sheetField.allot = sheetField.allotCache;
        return;
      }
      const param: object = {
        sheet_field_idx: state.sheetFields.indexOf(sheetField),
        allot: sheetField.allot
      };

      await http.post(`/api/saiten_list/update_allot/${state.sheet.id}`, param).then(response => {
        alert("配点の変更が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_id = context.root.$route.params.sheet_id;
      await http.get(`/api/saiten_list?sheet_id=${state.sheet_id}`).then(response => {

        state.sheet = new Sheet(response.data.sheet);
        state.delayedJobCount = response.data.create_pdf_job_count

        const fieldActivities: FieldActivity[] = response.data.field_activities.map((x: any) => new FieldActivity(x));
        const sheetActivities: SheetActivity[] = new Array<SheetActivity>();
        response.data.sheet_activities.forEach((x: any) => {
          sheetActivities.push(new SheetActivity(x));
        });

        response.data.students.forEach((x: any) => {
          state.students.push(new Student(x, sheetActivities, fieldActivities, response.data.exists_result_image_student_nos));
        });

        response.data.sheet_fields.forEach((x: any) => {
          state.sheetFields.push(new SheetField(x, fieldActivities));
        });

        const attendStudents = state.students.filter(x => x.sheetActivities.length > 0);
        let totalScore = Common.sumArray(attendStudents.map(x => x.score));
        const totalAllot = state.sheet.allot * attendStudents.length;
        state.totalScoreAverage = Number((totalScore / attendStudents.length).toFixed(1));
        state.totalScoreRate = Math.round(totalScore / totalAllot * 100);
        state.totalFieldCount = state.sheetFields.length * attendStudents.length;
        state.totalFirstSaitenCompletedCount = Common.sumArray(state.sheetFields.map(x => x.firstSaitenCompletedCount));

        state.isSaitenCompleted = state.totalFirstSaitenCompletedCount == state.totalFieldCount;          

        state.isPdfJobProcessing = response.data.is_pdf_processing;
        const studentNameMaxLength = state.students.map(x => x.student_name == null ? 0 : x.student_name.length).reduce((a,b)=>Math.max(a,b));
        state.studentNameWidth = studentNameMaxLength > 3 ? studentNameMaxLength * 20 : 65;
        
        let rightTableTdWidth = 0;

        const fieldNames: string[] = state.sheetFields.map(x => `${x.part1}${x.part2}${x.part3}`.replace("null", ""));
        let fieldNameMaxLength = fieldNames.map(x => x.length).reduce((a,b)=>Math.max(a,b));
        rightTableTdWidth = fieldNameMaxLength > 3 ? fieldNameMaxLength * 20 : 80;
        state.rightTableTdWidth = `${rightTableTdWidth}px`;

        for(let i = 1; i <= 100; i++){
          state.scoreOptions.push(new ScoreOption(i, `${i}点`));
        }
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        window.history.back();
      });
      
      adjustHeight();
      window.addEventListener("resize", adjustHeight);
      document.getElementById("bottom-right-table-area").onscroll = scrollChanged;
      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      modalRef,
      carouselRef,
      convertExecDateText,
      createPdfJob,
      downloadExcel,
      sortStudentNo,
      sortTotalScore,
      sortFieldScore,
      base64Images,
      modalTitle,
      showModalImage,
      carouselPrev,
      carouselNext,
      changePrevModalStudent,
      changeNextModalStudent,
      allSelectChanged,
      downloadPdf,
      saitenStart,
      isExcelPdfButtonEnable,
      isPdfButtonVisible,
      updateApproval,
      allotChanged,
    };
  }
})
